// PDP Subscription Toggle & Event Handlers
$(document).on('click', '.pdp-subscription__button--one-time', function() {
  var $this = $(this);
  $this.addClass('active').siblings().removeClass('active');
  $('.pdp-subscription__delivery').removeClass('active');
  
  // Set selling plan input to empty for One-Time Purchase
  var container = $this.closest('.fg-pdp-info');
  container.find('input[name="selling_plan"]').val('');
  
  setTimeout(() => {
    var Simpleprice = $this.find('.pdp-subscription__option-simple-price').text();
    console.log('Simpleprice', Simpleprice);
    container.find('.pdp-price-row .fg_regular_price,.pdp-price-row .fg_compare_price').text(Simpleprice);
  }, 300);
});

$(document).on('click', '.pdp-subscription__button--subscribe', function() {
  var $this = $(this);
  $this.addClass('active').siblings().removeClass('active');
  $('.pdp-subscription__delivery').addClass('active');
  
  // Get active delivery selling plan ID and update selling_plan input
  var container = $this.closest('.fg-pdp-info');
  var val = container.find('.pdp-subscription__delivery-item.active').data('val') || container.find('.pdp-subscription__delivery-item').first().data('val');
  container.find('input[name="selling_plan"]').val(val);
  
  setTimeout(() => {
    var Subprice = $this.find('.pdp-subscription__option-save-price').text();
    console.log('Subprice', Subprice);
    container.find('.pdp-price-row .fg_regular_price,.pdp-price-row .fg_compare_price').text(Subprice);
  }, 300);
});

$(document).on('click', '.swatch-item', function() {
  var simplePrice = $(this).data('price');
  var salePrice = $(this).data('sale-price'); // Apply 15% discount
  console.log('price', simplePrice);
  $('.pdp-subscription__button--one-time .pdp-subscription__option-price').attr('data-simple-price', simplePrice);
  $('.pdp-subscription__button--one-time .pdp-subscription__option-simple-price').text(simplePrice);
  $('.pdp-subscription__button--subscribe .pdp-subscription__option-save').attr('data-subscribe-price', salePrice);
  $('.pdp-subscription__button--subscribe .pdp-subscription__option-save-price').text(salePrice);
  setTimeout(() => {
    if ($('.pdp-subscription__button--one-time.active').length > 0) {
      console.log('btn_1');
      $('.price-item.fg_regular_price').text(simplePrice);
    } else {
      console.log('btn_2');
      $('.price-item.fg_regular_price').text(salePrice);
    }
  }, 300);
});

$('body').on('click', '.pdp-subscription__delivery-item', function() {
  var $this = $(this);
  $this.addClass('active').siblings().removeClass('active');
  var val = $this.data('val');
  
  var container = $this.closest('.fg-pdp-info');
  // Automatically switch tab to Subscribe & Save when clicking an interval
  container.find('.pdp-subscription__button--subscribe').addClass('active').siblings().removeClass('active');
  $('.pdp-subscription__delivery').addClass('active');
  
  container.find('input[name="selling_plan"]').val(val);
});

// Sync custom quantity radio selections
$('body').on('click', '.pdp-subscription__quantity input[type="radio"]', function() {
  var val = $(this).val();
  $(this).closest('.fg-pdp-info').find('input.quantity__input').val(val);
});

$(document).ready(function() {
  // Initialize selling plan input value on page load
  var container = $('.fg-pdp-info');
  if ($('.pdp-subscription__button--subscribe.active').length > 0) {
    var defaultVal = $('.pdp-subscription__delivery-item.active').data('val') || $('.pdp-subscription__delivery-item').first().data('val');
    container.find('input[name="selling_plan"]').val(defaultVal);
  } else {
    container.find('input[name="selling_plan"]').val('');
  }
});



document.addEventListener('DOMContentLoaded', function() {
  // Use event delegation on the document body to handle click events on read-more and read-less triggers
  document.addEventListener('click', function(event) {
    const readMoreBtn = event.target.closest('.pdp-read-more');
    const readLessBtn = event.target.closest('.pdp-read-less');

    if (readMoreBtn) {
      const wrapper = readMoreBtn.closest('.pdp-description-wrapper');
      if (!wrapper) return;
      
      const shortDiv = wrapper.querySelector('.pdp-description-short');
      const fullDiv = wrapper.querySelector('.pdp-description-full');
      
      if (shortDiv && fullDiv) {
        // Fade out short version first
        shortDiv.style.transition = 'opacity 0.2s ease';
        shortDiv.style.opacity = '0';
        
        setTimeout(function() {
          shortDiv.style.display = 'none';
          
          // Show full version wrapper collapsed (display: block but height: 0)
          fullDiv.style.display = 'block';
          fullDiv.style.height = '0px';
          fullDiv.style.opacity = '0';
          fullDiv.style.transition = 'height 0.4s ease, opacity 0.4s ease';
          
          // Force reflow/layout repaint
          fullDiv.offsetHeight;
          
          // Expand to scrollHeight
          const targetHeight = fullDiv.scrollHeight;
          fullDiv.style.height = targetHeight + 'px';
          fullDiv.style.opacity = '1';
          wrapper.classList.remove('collapsed');
          wrapper.classList.add('expanded');
          
          // Set height to auto after slide animation is complete to keep page layout responsive on resize
          setTimeout(function() {
            if (wrapper.classList.contains('expanded')) {
              fullDiv.style.height = 'auto';
            }
          }, 400);
        }, 200);
      }
    }

    if (readLessBtn) {
      const wrapper = readLessBtn.closest('.pdp-description-wrapper');
      if (!wrapper) return;
      
      const shortDiv = wrapper.querySelector('.pdp-description-short');
      const fullDiv = wrapper.querySelector('.pdp-description-full');
      
      if (shortDiv && fullDiv) {
        // Set fixed height in pixels before animating back to 0px
        fullDiv.style.height = fullDiv.scrollHeight + 'px';
        
        // Force reflow/layout repaint
        fullDiv.offsetHeight;
        
        // Slide up
        fullDiv.style.height = '0px';
        fullDiv.style.opacity = '0';
        wrapper.classList.remove('expanded');
        wrapper.classList.add('collapsed');
        
        setTimeout(function() {
          fullDiv.style.display = 'none';
          
          // Show short version
          shortDiv.style.display = 'block';
          shortDiv.style.opacity = '0';
          
          // Force reflow
          shortDiv.offsetHeight;
          
          // Fade in short version
          shortDiv.style.transition = 'opacity 0.2s ease';
          shortDiv.style.opacity = '1';
        }, 400);
      }
    }
  });
});



   